// Translations for the Recruitment page (frontend/src/pages/Recruitment/Recruitment.js)
// Note: much of this page's source text is authored in Swahili; t() works
// bidirectionally, so each pair's `sw` (or `en`) value matches the literal
// source string exactly as written in the component.
const recruitmentDict = [
  // Swahili-authored source strings
  { en: "Are you sure you want to delete this job posting?", sw: "Je, una uhakika unataka kufuta tangazo hili la kazi?" },
  { en: "Job Postings", sw: "Matangazo ya Ajira" },
  { en: "Manage job postings and applications", sw: "Dhibiti matangazo ya kazi na maombi" },
  { en: "New Posting", sw: "Tangazo Jipya" },
  { en: "Apply for a Job", sw: "Omba Kazi" },
  { en: "Total Postings", sw: "Jumla ya Matangazo" },
  { en: "Open Jobs", sw: "Zilizo Wazi" },
  { en: "Total Applications", sw: "Jumla ya Maombi" },
  { en: "Pending", sw: "Inasubiri" },
  { en: "Shortlisted", sw: "Waliochaguliwa" },
  { en: "Job Postings", sw: "Matangazo ya Ajira" },
  { en: "Applications", sw: "Maombi" },
  { en: "Type:", sw: "Aina:" },
  { en: "Location:", sw: "Mahali:" },
  { en: "Salary:", sw: "Msho:" },
  { en: "Not specified", sw: "Haijabainishwa" },
  { en: "Posted Date:", sw: "Tarehe ya Kutoa:" },
  { en: "Application Deadline:", sw: "Mwisho wa Maombi:" },
  { en: "Applications:", sw: "Maombi:" },
  { en: "Edit", sw: "Hariri" },
  { en: "Apply", sw: "Omba" },
  { en: "Delete", sw: "Futa" },
  { en: "No job postings found.", sw: "Hakuna matangazo ya kazi." },
  { en: "Name", sw: "Jina" },
  { en: "Posting", sw: "Tangazo" },
  { en: "Phone", sw: "Simu" },
  { en: "Date", sw: "Tarehe" },
  { en: "Status", sw: "Hali" },
  { en: "Actions", sw: "Vitendo" },
  { en: "No applications found.", sw: "Hakuna maombi ya kazi." },
  { en: "Edit Posting", sw: "Hariri Tangazo" },
  { en: "Job Title *", sw: "Kichwa cha Kazi *" },
  { en: "Employment Type *", sw: "Aina ya Ajira *" },
  { en: "Description *", sw: "Maelezo *" },
  { en: "Requirements", sw: "Mahitaji" },
  { en: "Responsibilities", sw: "Majukumu" },
  { en: "Qualifications", sw: "Sifa" },
  { en: "Location", sw: "Mahali" },
  { en: "Salary", sw: "Mshahara" },
  { en: "Posted Date *", sw: "Tarehe ya Kutoa *" },
  { en: "Application Deadline *", sw: "Mwisho wa Maombi *" },
  { en: "Status *", sw: "Hali *" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Save", sw: "Hifadhi" },
  { en: "Select Posting *", sw: "Chagua Tangazo *" },
  { en: "-- Select --", sw: "-- Chagua --" },
  { en: "Full Name *", sw: "Jina Kamili *" },
  { en: "Phone *", sw: "Simu *" },
  { en: "Write about yourself and why you are suited for this job...", sw: "Andika maelezo kuhusu wewe na kwa nini unafaa kwa kazi hii..." },
  { en: "Submit Application", sw: "Wasilisha Maombi" },

  // English-authored source strings
  { en: "Failed to delete job", sw: "Imeshindwa kufuta tangazo la kazi" },
  { en: "Failed to save job", sw: "Imeshindwa kuhifadhi tangazo la kazi" },
  { en: "Application submitted successfully!", sw: "Ombi limewasilishwa kwa mafanikio!" },
  { en: "Failed to submit application", sw: "Imeshindwa kuwasilisha ombi" },
  { en: "Application status updated", sw: "Hali ya ombi imesasishwa" },
  { en: "Failed to update status", sw: "Imeshindwa kusasisha hali" },
  { en: "Loading...", sw: "Inapakia..." },
  { en: "Views:", sw: "Mionekano:" },
  { en: "Under Review", sw: "Inakaguliwa" },
  { en: "Interviewed", sw: "Amehojiwa" },
  { en: "Accepted", sw: "Amekubaliwa" },
  { en: "Rejected", sw: "Amekataliwa" },
  { en: "Full Time", sw: "Muda Kamili" },
  { en: "Part Time", sw: "Muda Mfupi" },
  { en: "Contract", sw: "Mkataba" },
  { en: "Temporary", sw: "Ya Muda" },
  { en: "Internship", sw: "Mafunzo kwa Vitendo" },
  { en: "e.g. 500,000 - 800,000 TSH", sw: "mfano 500,000 - 800,000 TSH" },
  { en: "Draft", sw: "Rasimu" },
  { en: "Open", sw: "Wazi" },
  { en: "Closed", sw: "Imefungwa" },
  { en: "Cancelled", sw: "Imeghairiwa" },
  { en: "Cover Letter", sw: "Barua ya Maombi" },
  { en: "Resume/CV", sw: "Wasifu/CV" },
  { en: "Add Application", sw: "Ongeza Ombi" },
  { en: "Job Vacancies", sw: "Matangazo ya Kazi" },
  { en: "All job vacancies", sw: "Nafasi zote za kazi" },
  { en: "All applicants", sw: "Waombaji wote" },
  { en: "Internal posting", sw: "Tangazo la ndani" },
  { en: "Deadline", sw: "Mwisho wa Maombi" },
  { en: "Views", sw: "Mionekano" },
  { en: "Send Application", sw: "Tuma Ombi" },
  { en: "View", sw: "Angalia" },
  { en: "Call", sw: "Piga simu" },
  { en: "selected", sw: "wamechaguliwa" },
  { en: "Select applications to change their status together", sw: "Chagua maombi ili kubadilisha hali yake kwa pamoja" },
  { en: "Select all", sw: "Chagua yote" },
  { en: "Select all on this page", sw: "Chagua yote ukurasa huu" },
  { en: "Clear selection", sw: "Ondoa uchaguzi" },
  { en: "New status", sw: "Hali mpya" },
  { en: "New status…", sw: "Hali mpya…" },
  { en: "Change status", sw: "Badilisha hali" },
  { en: "Updating…", sw: "Inabadilisha…" },
  { en: "Change the status of", sw: "Badilisha hali ya" },
  { en: "applications to", sw: "maombi kuwa" },
  { en: "applications updated.", sw: "maombi yamebadilishwa." },
  { en: "Select", sw: "Chagua" },
  { en: "Open", sw: "Fungua" },
  { en: "Application Number", sw: "Namba ya Ombi" },
  { en: "Documents", sw: "Nyaraka" },
  { en: "History", sw: "Historia" },
  { en: "Application Letter", sw: "Barua ya Kuomba Kazi" },
  { en: "Academic Certificates", sw: "Vyeti vya Taaluma" },
  { en: "Driving Licence / Trade Test", sw: "Leseni ya Udereva / Trade Test" },
  { en: "No documents attached.", sw: "Hakuna nyaraka zilizoambatishwa." },
  { en: "Withdrawn", sw: "Ameondoa Ombi" },
  { en: "Failed to load application", sw: "Imeshindwa kufungua ombi" },
  { en: "Document could not be opened.", sw: "Imeshindwa kufungua nyaraka." },
];

export default recruitmentDict;
